import script from "./single-video.vue?vue&type=script&lang=ts&setup=true"
export * from "./single-video.vue?vue&type=script&lang=ts&setup=true"

import "./single-video.vue?vue&type=style&index=0&id=4f39f205&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\yang'ya'fei\\Documents\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f39f205"]])

export default __exports__